import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { CambiarStatusViajeButton } from "./cambiostatus";
import { GuiaList } from "app/features/general/operativa/items/resumenchoferze/list/componentes/guias/list";

type Entity = models.ViajeZEDto;

export interface Props {
    value: Entity;
}

const ImprimirAcusesButton = kea.defaultProps(kea.Button, { children: "Imprimir acuses internos", iconClass: fa("print") });
const ImprimirManifiestoSalida = kea.defaultProps(kea.Button, { children: "Imprimir manifiesto salida", iconClass: fa("list-ol") });
const ImprimirManifiestoLlegada = kea.defaultProps(kea.Button, { children: "Imprimir manifiesto llegada", iconClass: fa("list-ol") });
const VerificarButton = kea.defaultProps(kea.Button, { children: "Consultar verificador", iconClass: fa("eye") });
/**
* Componente para editar un Entity
*/
export class ViajeZEForm extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    getField = formfields(() => ({
        ...this.props,
        readonly: true
    }), undefined);

    idViajeZE = createSelectorRx(this.value, value => value.IdRegistro);
    guias = createSelectorRx(this.idViajeZE, id => observeResource(resources.ViajeZE.GetGuiasEnViaje, id));

    onImprimirAcuses = async () => {
        const data = await resources.ViajeZE.ReporteAcusesInternos(this.idViajeZE(this.props));
        await kea.printPdf(data);
    }

    onImprimirManifiestoSalida = async () => {
        const data = await resources.ViajeZE.ReporteManifiesto(this.idViajeZE(this.props), true);
        await kea.printPdf(data);
    }

    onImprimirManifiestoLlegada = async () => {
        const data = await resources.ViajeZE.ReporteManifiesto(this.idViajeZE(this.props), false);
        await kea.printPdf(data);
    }

    onVerificar = async () => history.go("./verificar");

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Date = getField(kea.DateTime);
        const guias = this.guias(this.props);
        return (
            <div>
                <kea.Title titulo="Viaje de ZE" onRegresar={() => history.go("../")}>
                    <CambiarStatusViajeButton viaje={this.props.value} />
                    <ImprimirAcusesButton onClick={this.onImprimirAcuses} />
                    <ImprimirManifiestoSalida onClick={this.onImprimirManifiestoSalida} />
                    {
                        value.FechaFinalizoAppMovil &&
                        <ImprimirManifiestoLlegada onClick={this.onImprimirManifiestoLlegada} />
                    }
                </kea.Title>
                {kea.autogrid(3, [
                    <Text field="Folio" label="Folio" />,
                    <kea.Text label="Status" value={models.StatusViajeZE[value.Status]} readonly />,
                    <Text field="NombreUsuario" label="Usuario capturó" />,
                    <Text field="NombreSucursal" label="Sucursal" />,
                    <Date field="FechaCreacion" label="Fecha de creacón" />,
                    <Date field="FechaInicio" label="Fecha de inicio" />,
                    <Date field="FechaFinalizo" label="Fecha finalizó" />,
                    <Date field="FechaCancelacion" label="Fecha de cancelación" />,
                    <Text field="NombreChoferZE" label="Chofer" />,
                    <Text field="NombreVehiculoZE" label="Camión" />,
                ])}

                <GuiaList value={guias} />
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesZE/edit/form.tsx